<div class="modal" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'" tabindex="-1">
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
          <i class="bi bi-building-gear me-2"></i>Vendor Details Management
        </h5>
        <button type="button" class="btn-close btn-close-white" (click)="close()"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Vendor List View -->
        <div *ngIf="!isEditing">
          <!-- Search and Add Button -->
          <div class="row mb-3">
            <div class="col-md-8">
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-search"></i></span>
                <input type="text" class="form-control" placeholder="Search vendors by name or type..."
                       [(ngModel)]="searchTerm">
              </div>
            </div>
            <div class="col-md-4 text-end">
              <button class="btn btn-primary" (click)="openAddVendorForm()">
                <i class="bi bi-plus-circle me-2"></i>Add New Vendor
              </button>
            </div>
          </div>

          <!-- Vendors Table -->
          <div class="table-responsive">
            <table class="table table-hover table-striped">
              <thead class="table-light">
                <tr>
                  <th>Vendor Type</th>
                  <th>Company Name</th>
                  <th>Contact Person</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>City</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let vendor of filteredVendors">
                  <td><span class="badge bg-info">{{ vendor.vendorType }}</span></td>
                  <td>{{ vendor.companyName }}</td>
                  <td>{{ vendor.contactPerson.name }}</td>
                  <td>{{ vendor.contactPerson.mobileNumber }}</td>
                  <td>{{ vendor.contactPerson.emailAddress }}</td>
                  <td>{{ vendor.businessAddress.cityTown }}</td>
                  <td>
                    <button class="btn btn-sm btn-outline-primary me-1" (click)="editVendor(vendor)" title="Edit">
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-danger" (click)="deleteVendor(vendor)" title="Delete">
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="filteredVendors.length === 0">
                  <td colspan="7" class="text-center text-muted py-4">
                    <i class="bi bi-inbox me-2"></i>No vendors found
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Vendor Add/Edit Form -->
        <div *ngIf="isEditing">
          <form #vendorForm="ngForm">
            <!-- Vendor Type -->
            <div class="card mb-3">
              <div class="card-header bg-light">
                <h6 class="mb-0"><i class="bi bi-tag me-2"></i>Vendor Type</h6>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-label">Vendor Type <span class="text-danger">*</span></label>
                    <select class="form-select" [(ngModel)]="currentVendor.vendorType"
                            name="vendorType" required>
                      <option value="">Select vendor type...</option>
                      <option *ngFor="let type of vendorTypes" [value]="type">{{ type }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <!-- Company Information -->
            <div class="card mb-3">
              <div class="card-header bg-light">
                <h6 class="mb-0"><i class="bi bi-building me-2"></i>Company Information</h6>
              </div>
              <div class="card-body">
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label class="form-label">Company Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.companyName"
                           name="companyName" required>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label">Date Established</label>
                    <input type="date" class="form-control"
                           [(ngModel)]="currentVendor.dateEstablished"
                           name="dateEstablished">
                  </div>
                  <div class="col-md-3">
                    <label class="form-label">Company Type</label>
                    <select class="form-select"
                            [(ngModel)]="currentVendor.companyType"
                            name="companyType">
                      <option value="">Select type...</option>
                      <option *ngFor="let type of companyTypes" [value]="type">{{ type }}</option>
                    </select>
                  </div>
                </div>

                <!-- Business Address -->
                <h6 class="mb-2 text-muted">Business Address</h6>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label class="form-label">Building Name/Number</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.businessAddress.buildingNameNumber"
                           name="buildingNameNumber">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Street</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.businessAddress.street"
                           name="street">
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <label class="form-label">District/Area/Barangay</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.businessAddress.districtAreaBarangay"
                           name="districtAreaBarangay">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">City/Town</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.businessAddress.cityTown"
                           name="cityTown">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">State/Province/Region</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.businessAddress.stateProvinceRegion"
                           name="stateProvinceRegion">
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label class="form-label">Postal/Zip Code</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.businessAddress.postalZipCode"
                           name="postalZipCode">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Country</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.businessAddress.country"
                           name="country">
                  </div>
                </div>

                <!-- Company Details -->
                <div class="row">
                  <div class="col-md-4">
                    <label class="form-label">Company Registration Number</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.companyRegistrationNumber"
                           name="companyRegistrationNumber">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Tax Identification Number</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.taxIdentificationNumber"
                           name="taxIdentificationNumber">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Regulatory Compliance</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.regulatoryCompliance"
                           name="regulatoryCompliance">
                  </div>
                </div>
              </div>
            </div>

            <!-- Top Officer -->
            <div class="card mb-3">
              <div class="card-header bg-light">
                <h6 class="mb-0"><i class="bi bi-person-badge me-2"></i>Top Officer</h6>
              </div>
              <div class="card-body">
                <div class="row mb-3">
                  <div class="col-md-4">
                    <label class="form-label">Name</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.topOfficer.name"
                           name="topOfficerName">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Designation</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.topOfficer.designation"
                           name="topOfficerDesignation">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Landline Number</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.topOfficer.landlineNumber"
                           name="topOfficerLandline">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-label">Mobile Number</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.topOfficer.mobileNumber"
                           name="topOfficerMobile">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Email Address</label>
                    <input type="email" class="form-control"
                           [(ngModel)]="currentVendor.topOfficer.emailAddress"
                           name="topOfficerEmail">
                  </div>
                </div>
              </div>
            </div>

            <!-- Contact Person -->
            <div class="card mb-3">
              <div class="card-header bg-light">
                <h6 class="mb-0"><i class="bi bi-person me-2"></i>Contact Person</h6>
              </div>
              <div class="card-body">
                <div class="row mb-3">
                  <div class="col-md-4">
                    <label class="form-label">Name</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.contactPerson.name"
                           name="contactPersonName">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Designation</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.contactPerson.designation"
                           name="contactPersonDesignation">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Landline Number</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.contactPerson.landlineNumber"
                           name="contactPersonLandline">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-label">Mobile Number</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.contactPerson.mobileNumber"
                           name="contactPersonMobile">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Email Address</label>
                    <input type="email" class="form-control"
                           [(ngModel)]="currentVendor.contactPerson.emailAddress"
                           name="contactPersonEmail">
                  </div>
                </div>
              </div>
            </div>

            <!-- Accounting Contact -->
            <div class="card mb-3">
              <div class="card-header bg-light">
                <h6 class="mb-0"><i class="bi bi-calculator me-2"></i>Accounting Contact</h6>
              </div>
              <div class="card-body">
                <div class="row mb-3">
                  <div class="col-md-4">
                    <label class="form-label">Name</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.accountingContact.name"
                           name="accountingContactName">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Designation</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.accountingContact.designation"
                           name="accountingContactDesignation">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Landline Number</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.accountingContact.landlineNumber"
                           name="accountingContactLandline">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-label">Mobile Number</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.accountingContact.mobileNumber"
                           name="accountingContactMobile">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Email Address</label>
                    <input type="email" class="form-control"
                           [(ngModel)]="currentVendor.accountingContact.emailAddress"
                           name="accountingContactEmail">
                  </div>
                </div>
              </div>
            </div>

            <!-- Banking Information -->
            <div class="card mb-3">
              <div class="card-header bg-light">
                <h6 class="mb-0"><i class="bi bi-bank me-2"></i>Banking Information</h6>
              </div>
              <div class="card-body">
                <div class="row mb-3">
                  <div class="col-md-4">
                    <label class="form-label">Bank Name</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.banking.bankName"
                           name="bankName">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Account Name</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.banking.accountName"
                           name="accountName">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Account Number</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.banking.accountNumber"
                           name="accountNumber">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-8">
                    <label class="form-label">Bank Address</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.banking.bankAddress"
                           name="bankAddress">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">SWIFT Code</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.banking.swiftCode"
                           name="swiftCode">
                  </div>
                </div>
              </div>
            </div>

            <!-- Business Presence -->
            <div class="card mb-3">
              <div class="card-header bg-light">
                <h6 class="mb-0"><i class="bi bi-globe me-2"></i>Business Presence</h6>
              </div>
              <div class="card-body">
                <div class="row mb-3">
                  <div class="col-md-4">
                    <label class="form-label">Headquarters</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.headquarters"
                           name="headquarters">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Global Presence</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.globalPresence"
                           name="globalPresence">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Website</label>
                    <input type="url" class="form-control"
                           [(ngModel)]="currentVendor.website"
                           name="website">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <label class="form-label">Network/Agency Membership</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.networkAgencyMembership"
                           name="networkAgencyMembership">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Referred By Company Name</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="currentVendor.referredByCompanyName"
                           name="referredByCompanyName">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Date Started Engagement</label>
                    <input type="date" class="form-control"
                           [(ngModel)]="currentVendor.dateStartedEngagement"
                           name="dateStartedEngagement">
                  </div>
                </div>
              </div>
            </div>

            <!-- Services Offered (for Overseas Agents) -->
            <div class="card mb-3" *ngIf="currentVendor.vendorType === 'Overseas agents'">
              <div class="card-header bg-light">
                <h6 class="mb-0"><i class="bi bi-list-check me-2"></i>Services Offered</h6>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                             [(ngModel)]="currentVendor.servicesOffered.airFreightForwarding"
                             name="airFreightForwarding">
                      <label class="form-check-label">Air Freight Forwarding</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                             [(ngModel)]="currentVendor.servicesOffered.oceanFreightForwarding"
                             name="oceanFreightForwarding">
                      <label class="form-check-label">Ocean Freight Forwarding</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                             [(ngModel)]="currentVendor.servicesOffered.customsClearanceBrokerage"
                             name="customsClearanceBrokerage">
                      <label class="form-check-label">Customs Clearance/Brokerage</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                             [(ngModel)]="currentVendor.servicesOffered.warehousingDistribution"
                             name="warehousingDistribution">
                      <label class="form-check-label">Warehousing & Distribution</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                             [(ngModel)]="currentVendor.servicesOffered.supplyChainLogistics"
                             name="supplyChainLogistics">
                      <label class="form-check-label">Supply Chain & Logistics</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                             [(ngModel)]="currentVendor.servicesOffered.projectCargoHandling"
                             name="projectCargoHandling">
                      <label class="form-check-label">Project Cargo Handling</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                             [(ngModel)]="currentVendor.servicesOffered.dangerousGoodsHandling"
                             name="dangerousGoodsHandling">
                      <label class="form-check-label">Dangerous Goods Handling</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                             [(ngModel)]="currentVendor.servicesOffered.freightInsurance"
                             name="freightInsurance">
                      <label class="form-check-label">Freight Insurance</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                             [(ngModel)]="currentVendor.servicesOffered.doorToDoorDelivery"
                             name="doorToDoorDelivery">
                      <label class="form-check-label">Door-to-Door Delivery</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                             [(ngModel)]="currentVendor.servicesOffered.importExportDocumentation"
                             name="importExportDocumentation">
                      <label class="form-check-label">Import/Export Documentation</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                             [(ngModel)]="currentVendor.servicesOffered.ecommerceCustomsClearance"
                             name="ecommerceCustomsClearance">
                      <label class="form-check-label">E-commerce Customs Clearance</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Notes -->
            <div class="card mb-3">
              <div class="card-header bg-light">
                <h6 class="mb-0"><i class="bi bi-chat-left-text me-2"></i>Notes</h6>
              </div>
              <div class="card-body">
                <textarea class="form-control" rows="3"
                          [(ngModel)]="currentVendor.notes"
                          name="notes"
                          placeholder="Additional notes or comments..."></textarea>
              </div>
            </div>

            <!-- Form Actions -->
            <div class="d-flex justify-content-between">
              <button type="button" class="btn btn-secondary" (click)="cancelEdit()">
                <i class="bi bi-x-circle me-2"></i>Cancel
              </button>
              <button type="button" class="btn btn-primary" (click)="saveVendor()" [disabled]="!vendorForm.form.valid">
                <i class="bi bi-save me-2"></i>Save Vendor
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div class="modal-backdrop fade" [class.show]="showModal" *ngIf="showModal"></div>
